
define('tpl!taoProctoring/component/activityMonitoring/progressbar', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"js-completed-assessments-refresh-bar refresh-bar\">\n    <div class=\"js-refresh-bar-progress refresh-bar-progress\"></div>\n</div>";
  });
});

